import React, { useEffect, useState } from 'react';
import { getEnv, loadScript } from '@ywfe/utils';

const ComponentLoader = (props: { componentPath: string }) => {
  const { componentPath } = props;
  const [route, setRoute] = useState<any>(null);

  const loadUmdPage = async (umd: any, name: string): Promise<void> => {
    if (umd && umd.js) {
      // 添加跨域属性
      await loadScript(umd, name, { crossOrigin: 'anonymous' });
    }
    setRoute({ component: (window as any)[umd.libName] });
  };

  // 通过域名获取当前环境
  const getResourcesId = (): string => {
    let env = getEnv();

    if (env === 'prod') {
      const isGray = window.localStorage.getItem('isGray');
      if (isGray === 'true') {
        env = 'gray';
      }
    }
    return env;
  };

  const loadUMD = (currentEnvPageUmd: any): void => {
    const currentUmd = componentPath && currentEnvPageUmd?.[componentPath];
    const pathUmd = {
      path: !componentPath.startsWith('/') ? `/${componentPath}` : componentPath,
      value: currentUmd,
      libName: currentUmd ? (currentUmd?.match(/\/(\w+).umd.js$/) as string[])?.[1] : '',
    };

    loadUmdPage({ js: pathUmd.value, libName: pathUmd.libName }, pathUmd.libName);
  };

  useEffect(() => {
    const env = getResourcesId();

    if ((window as any).pageUmdByEnv) {
      loadUMD((window as any).pageUmdByEnv);
      return;
    }

    const debug = window.localStorage.getItem('_debug') || window.location.search;
    const partPath = debug.includes('_debug') ? '/test' : '/prod';
    const version = Math.random();
    Promise.all(
      [
        window.fetch(`https://ywfedps.oss-cn-hangzhou.aliyuncs.com${partPath}/route.json?v=${version}`).then((response) => response.json()),
        window.fetch(`https://ywfedps.oss-cn-hangzhou.aliyuncs.com/devops${partPath}/ywCloud_${env}_config.json?v=${version}`).then((response) => response.json())
      ]
    ).then((data) => {
      const pageUmdV1 = data?.[0]?.ywCloud?.[env] || {};
      const pageUmdV2 = data?.[1]?.pageAssets || {}
        const pageUmdByEnv = {
          ...pageUmdV1,
          ...pageUmdV2
        };
        (window as any).pageUmdByEnv = pageUmdByEnv;
        loadUMD(pageUmdByEnv);
      });
  }, [componentPath]);

  return <>{ route && route.component ?  <route.component state={{ permissions: [] }} /> : <div></div>}</>;
};

export default ComponentLoader;
